export enum IconTypes {
  Custom = 'custom',
  MaterialIcon = 'material',
  // SVG = 'svg', // enable once more SVGs are converted to angular components
  SystemIcon = 'system',
  URL = 'url'
}

export interface IconProperties {
  type: IconTypes | 'custom' | 'material' | 'system' | 'url';
  path: string;
  style?: Partial<CSSStyleDeclaration>;
}
